import UserDealerData from '../dealer-settings/state/userDealerDataRequest';

export const validateDealerDetails = (fieldTouch, userDetails) => {

    if (fieldTouch && userDetails !== '') {

        const userIdList = userDetails.split(',');
        if (userIdList.length > 1 && userIdList.findIndex((x) => x.includes('*')) > -1) {

            return 'Cannot have multiple Ids with WildCards';

        } if (userIdList.length === 1 && userIdList[0].includes('*')) {

            if (userIdList[0].includes('**') || userIdList[0] === '*') {

                return 'Cannot have Single or Multiple WildCard w/o search field';

            }

        }

    }
    return '';

};

export const createUserDealerRequest = (userDealerDetails) => {

    let userDealerObj = {};

    const userId = userDealerDetails.userId.split(',');
    const dealerAccount = userDealerDetails.dealerAccount.split(',');

    if (userDealerDetails.userId !== '' && userId.length > 1) {

        userDealerObj = { ...userDealerObj, usersIds: userId };

    } if (userDealerDetails.userId !== '' && userId.length === 1) {

        userDealerObj = { ...userDealerObj, userIdsWild: userId[0] };

    } if (userDealerDetails.dealerAccount !== '' && dealerAccount.length > 1) {

        userDealerObj = { ...userDealerObj, dealerAccounts: dealerAccount };

    } if (userDealerDetails.dealerAccount !== '' && dealerAccount.length === 1) {

        userDealerObj = { ...userDealerObj, dealerAccountsWild: dealerAccount[0] };

    }
    return new UserDealerData({
        ...userDealerObj,
    });

};
